module.exports = __webpack_public_path__ + "static/media/btbms-mb-fr.0081c2ad.jpg";